export const UKRAINE = 'UA'
